<template>
  <v-card :loading="loading" class="elevation-1">
    <v-card-text class="pa-2 caption black--text">
      <apexchart type="donut" :height="155" :options="chartOptions" :series="series" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    series: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      loading: false,
      chartOptions: {
        chart: {
          type: 'donut',
        },
        title: {
          text: this.title
        },
        labels: this.categories,
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  showAlways: true,
                  show: true
                }
              }
            }
          }
        }
      }
    }
  },
  watch: {
    categories (val) {
      this.chartOptions = {
        ...this.chartOptions,
        labels: val
      }
    }
  }
}
</script>
